<div
  class="kwikui-star-rating-container"
  [formGroup]="formGroup"
  [class.small]="size === 's'"
  [class.medium]="size === 'm'"
  [class.large]="size === 'l'"
>
  <tui-rating
    [style.--tui-rating-color]="color"
    [disabled]="disabled"
    [formControl]="formControl"
    [iconFilled]="iconMarked"
    [iconNormal]="icon"
    [max]="max"
    [min]="min"
    [readOnly]="properties?.readOnly"
  ></tui-rating>
</div>
